import api from './api';
import type { UserProfile } from '../types';

export interface TokenPair {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface RegisterPayload {
  email: string;
  password: string;
  nome: string;
  cognome: string;
  ragioneSociale?: string;
  partitaIva?: string;
  // Extended B2B fields (synced to ERP on registration)
  codiceFiscale?: string;
  telefono?: string;
  pec?: string;
  codiceSdi?: string;
  indirizzo?: string;
  cap?: string;
  citta?: string;
  provincia?: string;
}

export const authService = {
  login: (email: string, password: string) =>
    api.post<TokenPair>('/api/auth/login', { email, password }),

  register: (data: RegisterPayload) =>
    api.post('/api/auth/register', data),

  refresh: (refresh_token: string) =>
    api.post<TokenPair>('/api/auth/refresh', { refresh_token }),

  /** Recupero password: la risposta è la stessa che l'email sia registrata o no. */
  forgotPassword: (email: string) =>
    api.post<{ message: string }>('/api/auth/password-dimenticata', { email }),

  /** Usa il link di recupero: nuova password, tutte le sessioni chiuse. */
  resetPassword: (token: string, new_password: string) =>
    api.post('/api/auth/reimposta-password', { token, new_password }),

  /** Chiude sul server la sessione di questo refresh token. */
  logout: (refresh_token: string) =>
    api.post('/api/auth/logout', { refresh_token }),

  me: () =>
    api.get<UserProfile>('/api/auth/me'),

  /**
   * Impersona via codice anagrafica NTS — usa shadow user se necessario.
   * Richiede lato backend ruolo admin/agente sul token chiamante: quando
   * si sta già impersonando (swap "Cambia" cliente senza terminare), il
   * token ATTIVO è quello del cliente corrente, quindi va passato
   * esplicitamente un access token admin di backup (``authToken``).
   */
  impersonateByAnConto: (anConto: number, authToken?: string) =>
    api.post<TokenPair>(
      `/api/auth/impersonate/anagrafica/${anConto}`,
      undefined,
      authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined,
    ),
};
